// import { Timestamp } from "@google-cloud/firestore";
import { Timestamp } from "firebase/firestore";

export const PraticanteModelo = (currentUser) => {
  return {
    matriculaCBTKD: "",
    dadosPessoais: {
      name: "",
      mothersName: "",
      fathersName: "",
      cpf: "",
      cnpj: "",
      birthdate: "",  // Usando string vazia para representar ausência de data (será Timestamp quando valorado)
      dataNascimentoCPF: "", // Campo específico para validação CPF na modal de cadastro simplificado
      estadoCivil: "",
      nacionalidade: "",
      apelido: "",
      urlImagemID: "",
      sexo: "",
    },
    metadados: {
      ownerid: currentUser?.uid || "",  // Usando string vazia em vez de undefined
      owner: currentUser?.displayName || "",  // Usando string vazia em vez de undefined
      creation: Timestamp.fromDate(new Date()),
      date: Timestamp.fromDate(new Date()),
      successorId: "",
      version: 0,
      active: false,
      federativeactive: false,
      aprovadoMestre: true,  // Definido como true por padrão (melhoria implementada)
      aprovadoFederacao: true,  // Definido como true por padrão (melhoria implementada)
      cancelado : false,
      blocked: false, // Mantido para compatibilidade retroativa
      bloqueado: {bloqueado: false}, // Cadastro bloquado por inadimplência
      desfiliado: {
        desfiliado: false,
        automaticFederativeRelation: false,
        federacao: "",
        federacaoID: "",
        matriculaFederacao: "",
        vinculadoAEntidade: "",
        vinculadoAEntidadeID: ""
      },
      bloqueioAdministrativo: false,  // Bloqueio administrativo (requer permissão 3100)
    },
    // usersgroupsowned: undefined,
    dadosContato: {
      email: "",
      celular: "",
      telefone: "",
      telefoneComercial: "",
    },
    dadosEndereco: {
      cep: "",
      logradouro: "",
      logradouroNumero: "",
      logradouroComplemento: "",
      logradouroBairro: "",
      logradouroMunicipio: "",
      logradouroUF: "",
    },
    dadosFiliacao: {
      automaticFederativeRelation: true,
      federacao: "",
      federacaoID: "",
      matriculaFederacao: "",
      vinculadoAEntidade: "",
      vinculadoAEntidadeID: "",
    },
    // dadosTaekwondo: undefined,
    // dadosColaborador: undefined,
    dadosBiograficos: {
      biografia: "",
    },
    documentos: [],
    anuidades: [],
  };
};
